import Matter from 'matter-js'

export default {

  mounted() {

    this.$debug = (this.level === "second") ? this.$parent.$parent.$debug : this.$parent.$debug
    this.$drag = (this.level === "second") ? this.$parent.$parent.$drag : this.$parent.$drag
    this.$pixi = (this.level === "second") ? this.$parent.$parent.$pixi : this.$parent.$pixi
    this.$World = (this.level === "second") ? this.$parent.$parent.$World : this.$parent.$World
    this.$Body = (this.level === "second") ? this.$parent.$parent.$Body : this.$parent.$Body
    this.$Bodies = (this.level === "second") ? this.$parent.$parent.$Bodies : this.$parent.$Bodies
    this.$Events = (this.level === "second") ? this.$parent.$parent.$Events : this.$parent.$Events
    this.$world = (this.level === "second") ? this.$parent.$parent.$world : this.$parent.$world
    this.$bodies = (this.level === "second") ? this.$parent.$parent.$bodies : this.$parent.$bodies
    this.$mask = (this.level === "second") ? this.$parent.$parent.$mask : this.$parent.$mask
    this.$names = (this.level === "second") ? this.$parent.$parent.$names : this.$parent.$names
    this.$events = (this.level === "second") ? this.$parent.$parent.$events : this.$parent.$events
    this.$couple = (this.level === "second") ? this.$parent.$parent.$couple : this.$parent.$couple

    this.$ratio = (window.innerWidth >= 1920) ? 1 : Math.round((window.innerWidth/1920)*100)/100
    this.$space = 300*this.$ratio
    this.$Constraint = Matter.Constraint
    this.$Vector = Matter.Vector

    this.$body_touch = 0x0001
    this.$bounds_touch = 0x0002
    this.$obstacle_touch = 0x0003
    this.$generic_touch = 0x0004
    this.$nothing_touch = 0x0005
    this.$blob_touch = 0x0006
    this.$other_touch = 0x0007

  },

  methods: {

    isBack(nw, od) {
      let b = false
      if(Number(nw.params.chapter.split('chapter')[1]) < Number(od.params.chapter.split('chapter')[1])) { b = true }
      else if (Number(nw.params.chapter.split('chapter')[1]) === Number(od.params.chapter.split('chapter')[1])
        && Number(nw.params.paragraph.split('paragraph')[1]) < Number(od.params.paragraph.split('paragraph')[1])) { b = true }
      return b
    }

  }

}